/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/DropdownList';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import Toggle from 'app/components/common/ToggleControl.jsx';
import ShortenerDetailBitly from 'app/components/ShortenerLists/ShortenerDetailBitly.jsx';
import ShortenerDetailCustom from 'app/components/ShortenerLists/ShortenerDetailCustom.jsx';
import ShortenerDetailDomain from 'app/components/ShortenerLists/ShortenerDetailDomain.jsx';
import ShortenerDetailWrapper from 'app/mixins/ShortenerDetailWrapper.jsx';
import * as _ from 'underscore';

class ShortenerType extends React.Component {
    render() {
        let Icon = IconFactory.customDomain;

        if (this.props.item.entityType === 'shortener') {
            Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.item.id, 'shortener')];
        }

        return (
            <div className="new-shortener-option">
                <div className="shortener-icon">
                    <Icon />
                </div>
                <div className="shortener-label">
                    {this.props.item.name}
                </div>
            </div>
        );
    }

};

class NewShortener extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentType: (this.props.shortenerType !== 0) ? this.props.shortenerType : 2, // SHORTEN_SVC_BITLY
            newShortener: {}
        };

        this.setDefaults = this.setDefaults.bind(this);
        this.onShortenerTypeChange = this.onShortenerTypeChange.bind(this);

    }

    componentDidMount() {
        let defaults = this.setDefaults(this.props.shortenerType);
        this.props.newShortener(defaults);
    }

    componentDidUpdate(prevProps, prevState) {

        if ((this.props.shortenerType !== prevProps.shortenerType)) {
            this.setState({
                currentType: parseInt(this.props.shortenerType, 10)
            });
            let defaults = this.setDefaults(this.props.shortenerType);
            if (this.props.creds) {
                defaults.credID = this.props.creds;
            }
            this.props.newShortener(defaults);
        }

    }

    setDefaults(type) {
        let update,
            constants = this.props.app.config.constants;

        switch (parseInt(type, 10)) {
            case constants.SHORTEN_SVC_BITLY:
                update = {
                    ssID: 2,
                    credID: '',
                    default: 0,
                    wrap: 0,
                    applyRoutes: 0,
                    applyOutputs: 0
                };
                break;

            case constants.SHORTEN_SVC_CUSTOM:
                update = {
                    ssID: 3,
                    name: '',
                    endpoint: '',
                    default: 0,
                    applyRoutes: 0,
                    applyOutputs: 0
                };
                break;

            case constants.PUB_DOMAIN:
                update = {
                    type: constants.PUB_DOMAIN,
                    url: '',
                    root: '',
                    default: 0,
                    applyRoutes: 0,
                    applyOutputs: 0
                };
                break;
        }

        return update;

    }

    onShortenerTypeChange(option) {
        let constants = this.props.app.config.constants,
            data = {};

        if (option.id !== undefined) {
            this.props.onNewTypeChange();

            data = this.setDefaults(option.id);

            // sets the state upstream in ShortenerDetailWrapper
            this.props.newShortener(data);

            this.setState({
                currentType: option.id,
                newShortener: {}
            });
        }

    }

    render() {
        let constants = this.props.app.config.constants,
            Panel = null,
            panelContent = null,
            types = [
                {id: constants.SHORTEN_SVC_BITLY, entityType: 'shortener', name: 'bit.ly'},
                {id: constants.SHORTEN_SVC_CUSTOM, entityType: 'shortener', name: '3rd Party Shortener'},
                {id: constants.PUB_DOMAIN, entityType: 'domain', name: 'Custom Domain'}
            ],
            defaultIndex = 0,
            saveButton = null,
            statusBlock = null,
            typeLabel = 'shortener',
            data = {};

        if (this.state.currentType == constants.SHORTEN_SVC_BITLY) {
            Panel = ShortenerDetailBitly;
        } else if (this.state.currentType == constants.SHORTEN_SVC_CUSTOM) {
            Panel = ShortenerDetailCustom;
        } else if (this.state.currentType == constants.PUB_DOMAIN) {
            Panel = ShortenerDetailDomain;
            typeLabel = 'domain';
        }

        panelContent = (
            <Panel
                {...this.props}
                type={this.state.currentType}
                errors={this.props.errors}
                state='new'
                creds={this.props.creds} />
        );

        if (_.isEmpty(this.props.errors) === false) {
            statusBlock = (
                <div className="detail-status error">
                    We couldn't create your {typeLabel}. Fix the errors below and try again.
                </div>
            );
        }

        for(let i = 0; i < types.length; ++i) {
            if (types[i].id == this.state.currentType) {
                defaultIndex = i;
                break;
            }
        }

        return (
            <li key="new" className="dlvr-list-item simple detail">
                <div className="list-item-display new-shortener">
                    <div className="new-shortener-control">
                        <DropdownList
                            containerClassName="shortener-dd"
                            data={types}
                            textField='name'
                            defaultValue={types[defaultIndex]}
                            value={types[defaultIndex]}
                            filter={false}
                            renderListItem={({ item }) => {
                                return (
                                    <ShortenerType
                                        item={item}/>
                                );
                            }}
                            renderValue={({ item }) => {
                                return (
                                    <ShortenerType
                                        item={item}/>
                                );
                            }}
                            onChange={this.onShortenerTypeChange} />
                    </div>
                </div>
                <div className="new-shortener-detail">
                    {statusBlock}
                    <form>
                        <div className="editor-panel">
                            {panelContent}
                        </div>
                    </form>
                </div>
            </li>
        );
    }

};

NewShortener.displayName = "NewShortener";

NewShortener.propTypes = {
    createShortener: PropTypes.func,
    creds: PropTypes.string,
    newShortnerType: PropTypes.number,
    errors: PropTypes.object,
    onNewTypeChange: PropTypes.func
};

NewShortener.defaultProps = {
    createShortener: null,
    creds: '',
    shortenerType: 0,
    errors: null,
    onNewTypeChange: null
};

export default ShortenerDetailWrapper(NewShortener);
